import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-755260b5")

_pushScopeId("data-v-755260b5")
const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "row p-2" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("small", { class: "tituloInfoDetalle" }, "Metropolitana", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Sucursales", -1)
const _hoisted_6 = { class: "row col-md-8" }
const _hoisted_7 = { class: "col-md-8" }
const _hoisted_8 = { class: "contenidoInfoDetalle" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "importeInfoDetalle" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = /*#__PURE__*/_createVNode("small", { class: "tituloInfoDetalle" }, "Áreas", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Corporativo", -1)
const _hoisted_14 = { class: "row col-md-12" }
const _hoisted_15 = { class: "col-md-8" }
const _hoisted_16 = { class: "contenidoInfoDetalle" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "importeInfoDetalle" }
const _hoisted_19 = { class: "col-md-10 d-flex justify-content-between" }
const _hoisted_20 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Suma áreas", -1)
const _hoisted_21 = { class: "importeInfoDetalle" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "col-md-6" }, null, -1)
const _hoisted_23 = { class: "row p-2" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = /*#__PURE__*/_createVNode("small", { class: "tituloInfoDetalle" }, "Interior de la República", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Sucursales", -1)
const _hoisted_27 = { class: "row col-md-8" }
const _hoisted_28 = { class: "col-md-8" }
const _hoisted_29 = { class: "contenidoInfoDetalle" }
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "importeInfoDetalle" }
const _hoisted_32 = { class: "col-md-7 d-flex justify-content-between" }
const _hoisted_33 = /*#__PURE__*/_createVNode("small", { class: "d-block subtituloInfoDetalle" }, "Suma sucursales", -1)
const _hoisted_34 = { class: "importeInfoDetalle" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "row col-md-8" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "col-md-5" }, [
  /*#__PURE__*/_createVNode("p", { class: "contenidoInfoDetalle fs-6" }, "Suma total")
], -1)
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "importeInfoDetalle fs-5" }
const _hoisted_40 = { class: "h-30 w-20 totalPagoDiv py-3" }
const _hoisted_41 = { class: "totalPago" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.MetroElegidas, (metroelegida) => {
          return (_openBlock(), _createBlock("div", {
            class: "row",
            key: metroelegida
          }, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("small", _hoisted_8, _toDisplayString(metroelegida.clave) + " - " + _toDisplayString(metroelegida.nombre), 1)
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("small", _hoisted_10, "$ " + _toDisplayString(_ctx.formatearImporte(metroelegida.monto)), 1)
              ])
            ])
          ]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _hoisted_13,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.AreasElegidas, (areaelegida) => {
          return (_openBlock(), _createBlock("div", {
            class: "row",
            key: areaelegida
          }, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("small", _hoisted_16, _toDisplayString(areaelegida.clave) + " - " + _toDisplayString(areaelegida.nombre), 1)
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("small", _hoisted_18, "$ " + _toDisplayString(_ctx.formatearImporte(areaelegida.monto)), 1)
              ])
            ])
          ]))
        }), 128)),
        _createVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode("small", _hoisted_21, [
            _createVNode("strong", null, " $ " + _toDisplayString(_ctx.formatearImporte(_ctx.sumaAreas)), 1)
          ])
        ])
      ]),
      _hoisted_22
    ]),
    _createVNode("div", _hoisted_23, [
      _createVNode("div", _hoisted_24, [
        _hoisted_25,
        _hoisted_26,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ForaneasElegidas, (foraneaelegida) => {
          return (_openBlock(), _createBlock("div", {
            class: "row",
            key: foraneaelegida
          }, [
            _createVNode("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _createVNode("small", _hoisted_29, _toDisplayString(foraneaelegida.clave) + " - " + _toDisplayString(foraneaelegida.nombre), 1)
              ]),
              _createVNode("div", _hoisted_30, [
                _createVNode("small", _hoisted_31, "$ " + _toDisplayString(_ctx.formatearImporte(foraneaelegida.monto)), 1)
              ])
            ])
          ]))
        }), 128)),
        _createVNode("div", _hoisted_32, [
          _hoisted_33,
          _createVNode("small", _hoisted_34, [
            _createVNode("strong", null, " $ " + _toDisplayString(_ctx.formatearImporte(_ctx.sumaSucursales)), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_35, [
        _createVNode("div", _hoisted_36, [
          _hoisted_37,
          _createVNode("div", _hoisted_38, [
            _createVNode("p", _hoisted_39, [
              _createVNode("strong", null, "$ " + _toDisplayString(_ctx.formatearImporte(_ctx.sumaSucursales + _ctx.sumaAreas)), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_40, [
          _createVNode("strong", _hoisted_41, "Total a pagar sin I.V.A: $ " + _toDisplayString(_ctx.formatearImporte(_ctx.sumaSucursales + _ctx.sumaAreas)), 1)
        ])
      ])
    ])
  ]))
})